import React from 'react';
import { Platform, Pressable, StyleSheet, Text, View } from 'react-native';

function reloadCurrentPage() {
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    window.location.reload();
  }
}

export function StuckLoadingRecovery() {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Still working on it…</Text>
      <Text style={styles.message}>
        This is taking longer than expected. Please reload the page to try again.
      </Text>
      <Pressable onPress={reloadCurrentPage} style={styles.button} accessibilityRole="button">
        <Text style={styles.buttonText}>Reload page</Text>
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
    paddingHorizontal: 32,
  },
  title: {
    fontSize: 20,
    fontWeight: '700',
    color: '#0D0D0D',
    marginBottom: 12,
    textAlign: 'center',
  },
  message: {
    fontSize: 15,
    fontWeight: '500',
    color: '#5C5854',
    textAlign: 'center',
    marginBottom: 24,
    lineHeight: 22,
  },
  button: {
    backgroundColor: '#E4572E',
    paddingHorizontal: 24,
    paddingVertical: 12,
    borderRadius: 8,
  },
  buttonText: {
    color: '#fff',
    fontSize: 15,
    fontWeight: '700',
  },
});
